import PageHandler from "./PageHandler";
import Pages from "Pages";

class UserDetailPageHandler extends PageHandler {
  constructor() {
    super("user-detail", Pages.UserDetailPage);
  }

  fetch(parameters) {
    let user = this.rootStore.data.UsersStore.findById(parameters.id);
    if (!user) this.rootStore.data.UsersStore.fetchId(parameters.id);
  }
}

export default UserDetailPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/UserDetailPageHandler.js